// extracted by mini-css-extract-plugin
export default {"content":"style_content__GtoI+","itemName":"style_itemName__C8ted"};